import { FormItemProps, InputProps, RadioGroupProps, SelectProps } from 'antd'

import { ComponentType } from 'react'

import CustomDatePickerField, {
  CustomDatePickerFieldProps,
} from 'shared/ui/Form/CustomDatePickerField'
import CustomPasswordFiled from 'shared/ui/Form/CustomPasswordFiled/CustomPasswordFiled'
import CustomSelectField, {
  CustomSelectFieldProps,
} from 'shared/ui/Form/CustomSelectField'
import CustomTextFiled, {
  CustomTextFieldProps,
} from 'shared/ui/Form/CustomTextFiled/CustomTextFiled'
import DatePicker, { DatePickerProps } from 'shared/ui/Form/DatePicker'
import FormItem from 'shared/ui/Form/FormItem/FormItem'
import InputPhoneNumber, {
  InputPhoneNumberProps,
} from 'shared/ui/Form/InputPhoneNumber/InputPhoneNumber'
import RadioGroup from 'shared/ui/Form/RadioGroup/RadioGroup'
import { Select } from 'shared/ui/Form/Select'
import TextFiled from 'shared/ui/Form/TextFiled'

const formItems = {
  datePicker: DatePicker,
  textField: TextFiled,
  select: Select,
  inputPhoneNumber: InputPhoneNumber,
  radioGroup: RadioGroup,
  customTextField: CustomTextFiled,
  customPasswordField: CustomPasswordFiled,
  customSelectField: CustomSelectField,
  customDatePickerField: CustomDatePickerField,
}

type ItemProps<T extends ItemTypes> = T extends 'datePicker'
  ? DatePickerProps
  : T extends 'textField' | 'customPasswordField'
    ? InputProps
    : T extends 'select'
      ? SelectProps
      : T extends 'inputPhoneNumber'
        ? InputPhoneNumberProps
        : T extends 'radioGroup'
          ? RadioGroupProps
          : T extends 'customTextField'
            ? CustomTextFieldProps
            : T extends 'customSelectField'
              ? CustomSelectFieldProps
              : T extends 'customDatePickerField'
                ? CustomDatePickerFieldProps
                : never
type ItemTypes = keyof typeof formItems

interface DefaultFormItem<T extends ItemTypes = ItemTypes, FormState = any> {
  type: T
  itemProps: ItemProps<T>
  formItemProps?: FormItemProps<FormState>
}

interface FormItemWithWrapper {
  withWrapper: {
    wrapperClassName: string
    items: DefaultFormItem[]
  }
}

export type RenderFormItem = DefaultFormItem | FormItemWithWrapper

interface Props {
  items: RenderFormItem[]
}

const FormItems = ({ items }: Props) => {
  return items.map((item, index) => {
    if ('withWrapper' in item) {
      const { wrapperClassName, items: withWrapperItems } = item.withWrapper
      return (
        <div
          key={index}
          className={wrapperClassName}
        >
          {withWrapperItems.map((withWrapperItem, index) => {
            const Component = formItems[
              withWrapperItem.type
            ] as ComponentType<any>
            return (
              <FormItem
                key={index}
                {...withWrapperItem.formItemProps}
              >
                <Component {...withWrapperItem.itemProps} />
              </FormItem>
            )
          })}
        </div>
      )
    }

    const Component = formItems[item.type] as ComponentType<any>
    return (
      <FormItem
        key={index}
        {...item.formItemProps}
      >
        <Component {...item.itemProps} />
      </FormItem>
    )
  })
}

export default FormItems
